const AT = require("../ActionTypes");

// Pass a vault to this function to make it so that if an action hasn't been
// dispatched for awhile, an UPDATE_TIMERS action gets dispatched. Allows
// OpsTimer to detect huge timer increments without risk of a false positive.

const UPDATE_THRESHOLD = 15000; // milliseconds

const addPeriodicUpdateFix = function(vault) {
	let timeout;
	const sendAction = () => {
		if (!vault.state.idle) {
			vault.dispatchNow({type: AT.UPDATE_TIMERS});
		}
		resetTimer();
	};
	const resetTimer = () => {
		clearTimeout(timeout);
		timeout = setTimeout(sendAction, UPDATE_THRESHOLD);
	};

	// Any action resets the timer.
	vault.addDispatchMiddleware(resetTimer);
	resetTimer();
};

module.exports = {
	addPeriodicUpdateFix,
};
